import { Loader2 } from 'lucide-react';

interface LazyLoadingFallbackProps {
  message?: string;
}

export function LazyLoadingFallback({ message = 'Loading...' }: LazyLoadingFallbackProps) {
  return (
    <div className="flex items-center justify-center min-h-[400px] w-full">
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}

// Specific fallbacks for different sections
export function DashboardLoadingFallback() {
  return <LazyLoadingFallback message="Loading dashboard..." />;
}

export function AssessmentLoadingFallback() {
  return <LazyLoadingFallback message="Loading assessments..." />;
}

export function ParticipantLoadingFallback() {
  return <LazyLoadingFallback message="Loading participants..." />;
}

export function OrganizationLoadingFallback() {
  return <LazyLoadingFallback message="Loading organization..." />;
}

export function AdminLoadingFallback() {
  return <LazyLoadingFallback message="Loading admin panel..." />;
}

export function ReportLoadingFallback() {
  return <LazyLoadingFallback message="Loading report..." />;
}

export function SurveyLoadingFallback() {
  return <LazyLoadingFallback message="Loading survey..." />;
}

export function WellnessCenterLoadingFallback() {
  return <LazyLoadingFallback message="Loading wellness center..." />;
}